// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"_6-z"};